// extracted by mini-css-extract-plugin
export default {"content":"_64A2q"};